import { mutatorAction } from 'satcheljs';
import isNewMailToastEnabled from '../selectors/isNewMailToastEnabled';
import isNewMailSoundEnabled from '../selectors/isNewMailSoundEnabled';
import isReminderToastEnabled from '../selectors/isReminderToastEnabled';
import isReminderSoundEnabled from '../selectors/isReminderSoundEnabled';
import { getUserConfiguration } from 'owa-session-store';
import NewNotification from 'owa-service/lib/contract/NewNotification';

export default mutatorAction('COMMIT_APP_NOTIFICATION_CHANGES_TO_USER_OPTIONS', () => {
    const userOptions = getUserConfiguration().UserOptions;

    userOptions.NewItemNotify = updateBitFlag(
        userOptions.NewItemNotify,
        NewNotification.EMailToast,
        isNewMailToastEnabled()
    );
    userOptions.NewItemNotify = updateBitFlag(
        userOptions.NewItemNotify,
        NewNotification.Sound,
        isNewMailSoundEnabled()
    );

    userOptions.EnableReminders = isReminderToastEnabled();
    userOptions.EnableReminderSound = isReminderSoundEnabled();
});

function updateBitFlag(base: NewNotification, flag: NewNotification, enabled: boolean) {
    // https://stackoverflow.com/questions/1436438/how-do-you-set-clear-and-toggle-a-single-bit-in-javascript
    return enabled ? base | flag : base & ~flag;
}
